import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge } from '@wit-support/ui';
import { Briefcase } from 'lucide-react';
/**
 * Marks a conversation whose sender writes on behalf of an organization (a pitch,
 * a vendor invoice, an automated notice) rather than as a private customer.
 *
 * Renders ONLY for `business`: the customer case is the overwhelming default, and
 * badging it would add noise to nearly every inbox row. Nothing here blocks or
 * hides anything — the badge just explains why no auto-reply went out.
 */
export const SenderCapacityBadge = ({ capacity, rationale, size = 'sm', className, }) => {
    if (capacity !== 'business')
        return null;
    return (_jsxs(Badge, { variant: "warning", size: size, className: className, title: rationale ?? undefined, "aria-label": "\u041A\u043E\u043C\u043C\u0435\u0440\u0447\u0435\u0441\u043A\u043E\u0435 \u043F\u0438\u0441\u044C\u043C\u043E", children: [_jsx(Briefcase, { className: size === 'sm' ? 'h-3 w-3' : 'h-3.5 w-3.5', "aria-hidden": "true" }), "\u041A\u043E\u043C\u043C\u0435\u0440\u0447\u0435\u0441\u043A\u043E\u0435"] }));
};
SenderCapacityBadge.displayName = 'SenderCapacityBadge';
/**
 * RU noun for a sender-capacity value — used wherever the value itself needs a
 * label rather than a badge, e.g. the manual-override history line ("Изменено
 * вручную: Клиент, …") in the conversation rail's classification card.
 */
export function senderCapacityLabel(value) {
    return value === 'business' ? 'Организация' : 'Клиент';
}
//# sourceMappingURL=sender-capacity-badge.js.map